import styled from "styled-components";

export const ObjectConnectionsDiv = styled.div`
  & h2 {
    margin: 0 0 var(--outerMargin) 0;
  }
  & h3 {
    margin: 0 0 var(--gap) 0;
  }
  & > div {
    display: flex;
    flex-wrap: wrap;
    & > div + div {
      margin-left: var(--gap);
    }
  }
  & ul {
    margin: 0 0 var(--gap) 0;
    padding: 0;
    list-style-type: none;
    & li {
      display: inline-block;
      white-space: nowrap;
      margin-right: 20px;
      &.selected {
        font-weight: bold;
      }
      & a {
        white-space: initial;
      }
    }
  }
`;
